<template>
  <div ref="box" class="box">
    <div ref="contentbox" class="scrollwrap">
      <div class="header" ref="headerbox">
        <div class="header_bg"></div>
        <div class="header_main">
          <div class="header_img" @click="showLive">
            <img :src="'http://avator.eastmoney.com/qface/'+headerImg+'/120'" alt />
            <!-- <img src="../../../public/images/myvideo/tx.png" alt /> -->
          </div>
          <div class="header_infos" v-if="isLogin==1">
            <p class="user_name_real">{{nickName}}</p>
          </div>
          <div class="header_infos" v-else>
            <p class="user_name">游客</p>
            <p class="user_jump" @click="jumpTo">去登录通行证账号</p>
          </div>
        </div>
      </div>
      <ul class="nav" ref="navbox">
        <li @click="current = 1;myCourses(1, 1)" :class="{ active: current == 1 }">
          <div class="nav_img">
            <img src="../../../public/images/myvideo/fx.png" alt />
          </div>
          <p class="nav_title">付费课程</p>
        </li>
        <!-- <li @click="current = 2;myCourses(2, 1)" :class="{ active: current == 2 }">
        <div class="nav_img">
          <img src="../../../public/images/myvideo/mf.png" alt />
        </div>
        <p class="nav_title">免费课程</p>
        </li>-->
        <li @click="current = 3;myCourses(3, 1)" :class="{ active: current == 3 }">
          <div class="nav_img">
            <img src="../../../public/images/myvideo/zj.png" alt />
          </div>
          <p class="nav_title">最近浏览</p>
        </li>
      </ul>
      <div class="content" ref="contentbox">
        <div v-show="current == 1">
          <div class="main_content" v-if="CourseList.length==0">
            <div class="no_content">
              <div class="no_content_img">
                <img src="../../../public/images/myvideo/no.png" alt />
              </div>

              <p @click="jumpCourse(1)">查看课程</p>
            </div>
          </div>
          <ul class="main" v-else>
            <li
              @click="getInfo(item.courseId, item.courseType)"
              v-for="item in CourseList"
              :key="item.courseId"
              style="position:relative;"
            >
              <div class="main_box">
                <div>
                  <img
                    v-if="item.hot"
                    style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                    src="../../../public/images/hot.png"
                    alt
                  />
                  <img
                    v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                    style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                    src="../../../public/images/new.png"
                    alt
                  />
                </div>
                <div class="main_left">
                  <img :src="item.imageUrl" alt />
                </div>
                <div class="main_right">
                  <p class="video_name">{{item.name}}</p>
                  <p class="video_teacher">{{item.teacher}}</p>
                  <div class="img_tab">
                    <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                  </div>
                  <p class="video_all">
                    已有
                    <span>{{item.viewQuantity}}</span>人看过
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-show="current == 2">
          <div class="main_content" v-if="CourseList.length==0">
            <div class="no_content">
              <div class="no_content_img">
                <img src="../../../public/images/myvideo/no.png" alt />
              </div>

              <p @click="jumpCourse(3)">查看课程</p>
            </div>
          </div>
          <ul class="main" v-else>
            <li
              @click="getInfo(item.courseId, item.courseType)"
              v-for="item in CourseList"
              :key="item.courseId"
              style="position:relative;"
            >
              <div class="main_box">
                <div>
                  <img
                    v-if="item.hot"
                    style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                    src="../../../public/images/hot.png"
                    alt
                  />
                  <img
                    v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                    style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                    src="../../../public/images/new.png"
                    alt
                  />
                </div>
                <div class="main_left">
                  <img :src="item.imageUrl" alt />
                  <!-- <img src="../../../public/images/tx.png" alt /> -->
                </div>
                <div class="main_right">
                  <p class="video_name">{{item.name}}</p>
                  <p class="video_teacher">{{item.teacher}}</p>
                  <div class="img_tab">
                    <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                  </div>
                  <p class="video_all">
                    已有
                    <span>{{item.viewQuantity}}</span>人看过
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-show="current == 3">
          <div class="main_content" v-if="CourseList.length==0">
            <div class="no_content">
              <div class="no_content_img">
                <img src="../../../public/images/myvideo/no.png" alt />
              </div>
            </div>
          </div>
          <ul class="main" v-else>
            <li
              @click="getInfo(item.courseId, item.courseType)"
              v-for="item in CourseList"
              :key="item.courseId"
              style="position:relative;"
            >
              <div class="main_box">
                <div>
                  <img
                    v-if="item.hot"
                    style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                    src="../../../public/images/hot.png"
                    alt
                  />
                  <img
                    v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                    style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                    src="../../../public/images/new.png"
                    alt
                  />
                </div>
                <div class="main_left">
                  <img :src="item.imageUrl" alt />
                </div>
                <div class="main_right">
                  <p class="video_name">{{item.name}}</p>
                  <p class="video_teacher">{{item.teacher}}</p>
                  <div class="img_tab">
                    <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
                  </div>
                  <p class="video_all">
                    已有
                    <span>{{item.viewQuantity}}</span>人看过
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <Header />
  </div>
</template>
<script>
import Header from "../../components/Header";
import { MyCourses } from "../../utils/http";
import { setCookie, getCookie } from "../../utils/cookie.js";
// import emH5Share from "../emH5Share.js";
export default {
  name: "myvideo",
  components: {
    Header
  },
  data() {
    return {
      current: 1,
      CourseList: [],
      isLogin: 0,
      ctoken: "",
      utoken: "",
      nickName: "",
      top: 0,
      page: 1,
      isLoadingMore: false,
      headerImg: "",
      date: new Date(),
      ct: "",
      ut: "",
      clickCount: 0,
      miniToken: ""
    };
  },
  mounted() {
    // emH5.ShareData = {
    //   title: "金牌课程",
    //   desc: "为您精选投资课程",
    //   link: window.location.href,
    //   // imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
    //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
    //   fail: function(res) {
    //     alert(JSON.stringify(res));
    //   }
    // };
    // emH5.Share();
    window.scrollTo(0, 0);
    window.AG.setTitle("我的课程");
    // var that = this;
    // window.AG.checkUserIsLogin(function(result) {
    //   if (result) {
    //     that.isLogin = 1;
    //     window.AG.getUserLoginSuccessData(function(json) {
    //       that.ctoken = json.ct;
    //       that.utoken = json.ut;
    //       that.nickName = decodeURIComponent(json.nickname);
    //       that.headerImg = json.uid;
    //       // window.debuggeruid = json.uid;
    //       that.myCourses(1, 1);
    //     });
    //   } else {
    //     that.isLogin = 0;
    //     that.ctoken = "";
    //     that.utoken = "";
    //     that.myCourses(1, 1);
    //   }
    // });
    if (window.AG.InApp) {
      var that = this;
      window.AG.checkUserIsLogin(function(result) {
        if (result) {
          that.isLogin = 1;
          window.AG.getUserLoginSuccessData(function(json) {
            that.ctoken = json.ct;
            that.utoken = json.ut;
            that.nickName = decodeURIComponent(json.nickname);
            that.headerImg = json.uid;
            // window.debuggeruid = json.uid;
            that.myCourses(1, 1);
          });
        } else {
          that.isLogin = 0;
          that.ctoken = "";
          that.utoken = "";
          that.myCourses(1, 1);
        }
      });
    } else {
      this.ctoken = getCookie("ct");
      this.utoken = getCookie("ut");
      if (this.ctoken && this.utoken) {
        this.isLogin = 1;
        this.nickName = decodeURIComponent(getCookie("uidal").substring(16));
        this.headerImg = getCookie("uidal").substring(0, 16);
        this.myCourses(1, 1);
      } else {
        this.ctoken = "";
        this.utoken = "";
        this.myCourses(1, 1);
        this.isLogin = 0;
      }
    }
    this.getHeight();
    this.overscroll(document.querySelector(".scrollwrap"));
    document.addEventListener("scroll", this.handleScroll);
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.addEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.removeEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
  },
  methods: {
    getHeight() {
      this.$refs.contentbox.scrollTop = 0;
      let heightWindow = window.innerHeight;
      let heightMain = heightWindow - 48;
      this.$refs.contentbox.style.height = heightMain + "px";
    },
    showLive() {
      this.clickCount++;
      console.log(this.clickCount);
      if (this.clickCount > 9) {
        setCookie("isPaidvideoLive", 1);
        window.location.reload();
      }
    },
    overscroll(el) {
      el.addEventListener("touchstart", function() {
        var top = el.scrollTop,
          totalScroll = el.scrollHeight,
          currentScroll = top + el.offsetHeight;
        if (top === 0) {
          el.scrollTop = 1;
        } else if (currentScroll === totalScroll) {
          el.scrollTop = top - 1;
        }
      });

      el.addEventListener("touchmove", function(evt) {
        if (el.offsetHeight < el.scrollHeight) {
          evt._isScroller = true;
        }
      });
    },
    listenScroll(evt) {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
      var scroll = scrollTop - this.top;
      this.top = scrollTop;
      if (scroll >= 0) {
        this.srollTest();
      }
    },
    srollTest() {
      if (
        this.$refs.contentbox.offsetHeight -
          this.getClientHeight() -
          Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          ) <=
        30
      ) {
        if (this.isLoadingMore) {
          return;
        }
        this.isLoadingMore = true;
        this.page++;
        this.myCourses(this.current, this.page);
      }
    },
    myCourses(type, page) {
      MyCourses({
        coursesType: type,
        pageNum: page,
        pageSize: 10,
        ctoken: this.ctoken || this.ct,
        utoken: this.utoken || this.ut
      }).then(res => {
        if (res.data.code == 0) {
          if (page == 1) {
            this.CourseList = res.data.data;
            this.page = page;
            this.isLoadingMore = false;
          } else {
            if (res.data.data.length != 0) {
              this.CourseList = this.CourseList.slice(
                0,
                this.CourseList.length
              ).concat(res.data.data);
              this.page = page;
              this.isLoadingMore = false;
            } else {
              this.isLoadingMore = true;
            }
          }
        }
      });
    },
    getInfo(v, type) {
      if (type == 1 || type == 3) {
        //录播课程
        this.$router.push({ path: "/courseInfo", query: { courseId: v } });
      } else {
        this.$router.push({
          path: "/livecourse",
          query: { courseId: v, type }
        });
      }
    },
    jumpCourse(v) {
      this.$router.push({ path: "/course", query: { from: 0, n: v } });
    },
    jumpCoupon() {
      this.$router.push("/coupon");
    },
    jumpTo() {
      if (this.isLogin == 0) {
        window.AG.eventLogin(res => {
          if (+res.code === 0) {
            window.EM_USER_LOGIN_INFO = res.data;
            this.ctoken = res.data.ct;
            this.utoken = res.data.ut;
            this.nickName = decodeURIComponent(res.data.nickname);
            this.isLogin = 1;
            this.myCourses(1, 1);
          }
        });
        if (window.AG.InApp) {
          window.AG.eventLogin(res => {
            if (+res.code === 0) {
              window.EM_USER_LOGIN_INFO = res.data;
              this.ctoken = res.data.ct;
              this.utoken = res.data.ut;
              this.nickName = decodeURIComponent(res.data.nickname);
              this.isLogin = 1;
              this.myCourses(1, 1);
            }
          });
        } else {
          location.href =
            "https://mpassport.eastmoney.com/login?backUrl=" +
            encodeURIComponent(location.href);
          //跳转登录页
        }
      }
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // var hours =
      //   date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      // var minutes =
      //   date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // var seconds =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    }
  }
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 2.36rem;
  background-color: #f6f6f6;
  overflow: hidden;
  position: relative;
}
.scrollwrap {
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.header_main {
  width: 6.84rem;
  height: 1.94rem;
  margin: 0.21rem auto;
  position: absolute;
  left: 50%;
  z-index: 2;
  transform: translateX(-50%);
  background-color: #fff;
  border-radius: 20px 20px;
}
.header_img {
  float: left;
  width: 1.42rem;
  height: 1.44rem;
  margin: 0.25rem 0.32rem 0.25rem 0.26rem;
  border-radius: 50%;
  border: 1px solid #f5f5f5;
}
.header_img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.header_infos {
  float: left;
  padding: 0.45rem 0;
  color: #3a3a3a;
}
.user_name {
  width: 4.5rem;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.44rem;
  text-align: left;
}
.user_name_real {
  width: 4.5rem;
  height: 0.98rem;
  line-height: 0.98rem;
  font-size: 0.44rem;
  text-align: left;
  overflow: hidden;
}
.user_jump {
  width: 4.5rem;
  height: 0.45rem;
  line-height: 0.45rem;
  font-size: 0.3rem;
  text-align: left;
}
.nav {
  width: 6.84rem;
  height: 1.76rem;
  padding: 0 0.33rem;
  background-color: #fff;
}
.nav li {
  float: left;
  width: 3.12rem;
  padding: 0.3rem 0;
  margin-right: 0.3rem;
  font-size: 0.28rem;
}
.nav li:last-child {
  margin-right: 0;
}
.nav_img {
  width: 0.72rem;
  height: 0.65rem;
  padding: 0 1.2rem;
  margin-bottom: 0.14rem;
}
.header_bg {
  position: absolute;
  z-index: 1;
  top: -2.6rem;
  left: 50%;
  transform: translateX(-50%);
  width: 9rem;
  height: 4rem;
  background: #0072dc;
  border-radius: 4rem;
}
.nav_img img {
  width: 100%;
  height: 100%;
}
.nav_title {
  height: 0.37rem;
  line-height: 0.37rem;
  font-size: 0.28rem;
  color: #666666;
}
.content {
  background-color: #f6f6f6;
  padding: 0.28rem 0 0rem;
}
.main_content {
  background-color: #fff;
  width: 100%;
  height: 9.14rem;
  padding-top: 1.5rem;
}
.no_content_img {
  margin: 0 auto 0.6rem;
  width: 3.15rem;
  height: 2.18rem;
}
.no_content img {
  width: 100%;
  height: 100%;
}
.no_content p {
  width: 2.55rem;
  height: 0.93rem;
  line-height: 0.93rem;
  font-size: 0.32rem;
  color: #ef4313;
  background-color: #fff;
  text-align: center;
  border-radius: 12px 12px;
  margin: 0 auto;
  border: 1px solid #ef4313;
}
.main {
  width: 100%;
  background-color: #fff;
}
.main li {
  width: 7.5rem;
}
.main_box {
  width: 7.07rem;
  margin: 0 auto;
  border-bottom: 1px solid #efefef;
  overflow: hidden;
}
.main_left {
  float: left;
  width: 3.33rem;
  height: 2.1rem;
  padding: 0.25rem 0.06rem;
}
.main_left img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}
.main_right {
  float: right;
  width: 3.5rem;
}
.video_name {
  line-height: 0.57rem;
  font-size: 0.32rem;
  margin-top: 0.25rem;
  text-align: left;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.video_teacher {
  line-height: 0.35rem;
  font-size: 0.28rem;
  text-align: left;
  color: #666666;
}
.img_tab {
  width: 3.5rem;
  height: 0.45rem;
  margin: 0.3rem 0;
  overflow: hidden;
}
.img_tab p {
  float: left;
  height: 0.38rem;
  /* line-height: 0.38rem; */
  border: 1px solid #ea5503;
  border-radius: 30px 30px;
  margin: 0 0.13rem 0.2rem 0;
  font-size: 0.2rem;
  color: #ea5503;
  padding: 0 0.1rem;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.video_all {
  text-align: right;
  width: 3.1rem;
  height: 0.42rem;
  line-height: 0.42rem;
  font-size: 0.24rem;
  color: #999999;
  margin-bottom: 0.1rem;
}
.active p {
  color: #f25a0e;
}
</style>
